export default __webpack_public_path__ + "static/media/Belt of Bristling Ire.2172b6c0.jpg";